import { dateToView } from "helpers/date";
import React from "react";

export default function BillingPayments(props) {
    if (!props.items.length) {
        return <h6 className="text-center my-5">Данные отсутствуют</h6>;
    }
    return (
        <table className="table table-sm">
            <thead>
                <tr>
                    <th>Название</th>
                    <th>Дата оплаты</th>
                    <th>Код оплаты</th>
                    <th>Комментарий</th>
                </tr>
            </thead>
            <tbody>
                {props.items.map((item) => (
                    <tr key={item.id}>
                        <td>{item.agreementName}</td>
                        <td>{dateToView(item.payDate)}</td>
                        <td>{item.payCode}</td>
                        <td>{item.comment}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
